export default __webpack_public_path__ + "static/media/loader.7f36ed10.svg";